'use strict';

module.exports = {
  inserted: function(element) {
    element.focus();
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/scripts/shared/directives/autofocus.js
// module id = 201
// module chunks = 0